module.exports = __webpack_public_path__ + "static/media/ICT-21.c8ecea1e.jpg";